import {
	Box,
	Button,
	FormControl,
	FormLabel,
	MenuItem,
	Stack,
	TextField,
	Tooltip,
} from "@mui/material";
import Tree from "rc-tree";
import React, {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState,
} from "react";
import { useTranslation } from "react-i18next";
import TPDropDown from "./TPDropDown";
import TradingPartnerContextMenu from "./TradingPartnerContextMenu";
import { fieldTypeOptionsArray } from "../../constants/constantList";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep, debounce } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import SourceType from "./SourceType";
import AdvancedProperties from "../ItemProperties/Forms/Advanced Properties/AdvancedProperties";
import CommonGrid from "../Repository/CommonGrid";
import LightTooltip from "../../commonComponents/LightTooltip";

const fieldTypeArray = [
	...fieldTypeOptionsArray,
	{ value: "CONSTANT", text: t("CONSTANT") },
];

const newTradingPartnerLookupData = {
	FIELDTYPE: "CONSTANT",
	VALUE: "",
};

const TradingPartnerData = () => {
	const { t } = useTranslation();
	const parentScreen = useContext(ParentScreenCtx);
	const [treeData, setTreeData] = useState([]);
	const [selectedLookup, setSelectedLookup] = useState([]);
	const [selectedLookupNode, setSelectedLookupNode] = useState({});
	const [index, setIndex] = useState(0);
	const [lookupData, setLookupData] = useState([]);
	const [constantValue, setConstantValue] = useState("");
	const [openAdvancedPropertiesModal, setOpenAdvancedPropertiesModal] =
		useState(false);
	const [rowData, setRowData] = useState([]);
	const [selectedTPL, setSelectedTPL] = useState({});
	const [gridAPI, setGridAPI] = useState(null);
	const initialTradingPartner = useSelector(
		(state) => state.treeData.outbound.rightTree.tree.initialTemplateHeader.TRADING_PARTNER
	);
	const tradingPartner = useSelector(
		(state) => state.treeData.outbound.rightTree.tree.templateHeader.TRADING_PARTNER
	);
	const { leftTree, rightTree } = useSelector(
		(state) => state.treeData[parentScreen]
	);
	const leftSelectedNode = leftTree.tree.body.selectedNode;
	const dispatch = useDispatch();
	const timer = useRef();
	const fieldTypeDropDownItems =
		fieldTypeArray?.map((obj, key) => (
			<MenuItem key={key} value={obj.value}>
				{t(obj.text)}
			</MenuItem>
		)) || [];

	const valuesHandler = (values) => {
		if(values?.hasOwnProperty("FIELDTYPE")) delete values["FIELDTYPE"];
		changeHandler(null, null, values);
	};

	const updateSelectedNode = (val) => {
		changeHandler(null, null, val);
	};

	const customClickHandlerOnAdd = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
			...newTradingPartnerLookupData,
		});
		lookupDataHandler(
			[...data],
			data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
			e.api
		);
		submitChange(data);
	};

	const deleteActionHandler = (e) => {
		const data = [];
		e.api.forEachNode((node) => {
			if (e.data.id !== node.data.id) data.push(node.data);
		});
		lookupDataHandler([...data], 0, e.api);
		submitChange(data);
	};

	const copyActionHandler = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, selectedRows?.[0]);
		lookupDataHandler([...data], +selectedRows?.[0]?.id + 1, e.api);
		submitChange(data);
	};

	const lookupDataHandler = (data = [], selectionIndex, gridAPI) => {
		if (!gridAPI) {
			setRowData([]);
			return;
		}
		const rowData = data?.map((e, i) => {
			let title = t("MNU_LOOKUP_FLD");
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption('rowData', rowData)

		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					setSelectedTPL(node.data);
					gridAPI.ensureNodeVisible(node);
				}
			});
			if (!rowData?.length) setSelectedTPL({});
		}, 100);
	};

	const CustomCellRenderer = (info) => {
		const { value, data } = info;
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: "2rem",
				}}
			>
				<div className='truncated-text' title={value}>
					{value}
				</div>
				<div className='flex align-center'>
					<LightTooltip onClick={() => deleteActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='DELETE_MUI'
							// onClick={() => handleDelete(value, data?.data)}
						></span>
					</LightTooltip>
					<LightTooltip onClick={() => copyActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='FILE_COPY'
							// onClick={() => handleCopy(value, data?.data)}
						></span>
					</LightTooltip>
				</div>
			</div>
		);
	};

	let gridOptions = {
		columnDefs: [
			{
				addNewControl: true,
				addControlLabel: t("HOVER_MSSG_ADD_TRADING_PARTNER_LOOKUP_DATA"),
				customClickHandlerOnAdd: customClickHandlerOnAdd,
				headerName: t("LBL_TRADE_PARTNER_LOOKUP_DATA"),
				field: "key",
				editable: false,
				resizable: false,
				cellRenderer: (info) => CustomCellRenderer(info),
				rowDrag: true,
			},
		],
		onRowDragEnd: function (event) {
			// Handle row drag end event here
			const newRowData = [];
			const selectedNodes = event.api.getSelectedRows();
			let newSelectedId = null;
			event.api.forEachNodeAfterFilterAndSort(function (node, i) {
				newRowData.push({ ...node.data, id: i });
				if (selectedNodes[0]?.id === node.data.id) newSelectedId = i;
			});
			submitChange(newRowData);
			event.api.setGridOption('rowData', newRowData)
			if (newSelectedId !== null)
				lookupDataHandler(newRowData, newSelectedId, event.api);
		},
		rowDragManaged: true,
	};
	const onSelectHandler = (gridOptions) => {
		const selectedRows = gridOptions.api.getSelectedRows();
		setSelectedTPL(selectedRows[0]);
	};

	const changeHandler = (key, value, values) => {
		if (!gridAPI) return;
		const data = [];
		const selectedSubstitution = gridAPI.getSelectedRows()?.[0] || {};
		gridAPI.forEachNode((node) => {
			if (node?.data?.id === selectedSubstitution?.id) {
				data.push({
					...node?.data,
					...(key ? {[key] : value} : values)
				});
			} else data.push(node?.data);
		});
		lookupDataHandler(data, selectedSubstitution?.id, gridAPI);
		submitChange(data);
	};

	const submitChange = (value) => {
		dispatch(
			treeActions.setRightTreeTemplateHeaders({
				screen: parentScreen,
				key: "TRADING_PARTNER",
				value: getCleanedData(value),
			})
		);
	};


	const getCleanedData = (data) => {
		const validKeys = [
			"FIELDTYPE",
			"VALUE",
			"MAPNAME",
			"RECORD_TYPE",
			"SOURCE_TYPE",
			"PARENT",
			"MAP_REPETITION_INDEX",
			"SOURCE_REPEATING_FIELD",
			"CUSTOM_DB_FIELD",
			"PLUGIN_NAME",
			"VARIABLE_COLLECTION_ACTION",
			"VARIABLE_COLLECTION_INDEX",
			"WF_ITEM_ID",
			"WF_ITEM_LOCATION",
			"REPLACE",
			"MASK",
			"FUNCTION",
			"SUBSTRING"
		]
		const newData = cloneDeep(data || [])?.map(e => {
			const newTPLD = {...e};
			Object.keys(newTPLD).forEach(key => {
				if(!validKeys.includes(key)) delete newTPLD?.[key]; 
			})

			if (newTPLD?.MAPNAME === t("SELECT") || newTPLD?.MAPNAME === "") {
				// Delete Redundant JSON;
				["MAPNAME","RECORD_TYPE","SOURCE_TYPE","PARENT"].forEach(e => {
					if(newTPLD?.hasOwnProperty(e)) delete newTPLD?.[e];
				})
			}
			if (newTPLD?.FIELDTYPE !== "CONSTANT" && newTPLD?.hasOwnProperty("VALUE")) delete newTPLD?.VALUE;

			return newTPLD
		})
		return newData;
	}


	const debounceChangeHandler = useCallback(
		debounce(changeHandler, 400),
		[leftSelectedNode?.key, gridAPI]
	);

	useEffect(() => {
		if(gridAPI){
			const tradingPartnerArray = tradingPartner || [];
			lookupDataHandler(tradingPartnerArray, 0, gridAPI);
			setLookupData(tradingPartnerArray || []);
		}
	}, [initialTradingPartner, gridAPI]);

	useEffect(() => {
		setConstantValue(selectedTPL?.VALUE || "");
	}, [selectedTPL]);

	return (
		<Box className='margin-top-25'>
			{/* <FormControl className="width-100 margin-top-25" size="small">
        <FormLabel>{t("LBL_TRADE_PARTNER_LOOKUP_DATA")}</FormLabel>
        <div
          className="div-textbox"
          id="tradingPartner"
          style={{ userSelect: "none" }}
        >
          <Tree
            selectedKeys={selectedLookup}
            treeData={treeData}
            selectable={true}
            icon={iconRender}
            onSelect={selectHandler}
            onRightClick={rightClickHandler}
          />
        </div>
        <TradingPartnerContextMenu 
          data={lookupData}
          updateTree={dataToRctree}
          setSelectedLookup={setSelectedLookup}
          setData={setLookupData}
          selectedLookup={selectedLookup}
          updateRedux = {lookupDataUpdater}
          setSelectedLookupNode={setSelectedLookupNode}
        />
      </FormControl> */}
			<CommonGrid
				rowData={rowData}
				gridOptions={gridOptions}
				containerStyle={{ height: 200 }}
				gridResizable={true}
				getGridAPI={(e, gridRef) => {
					setGridAPI(gridRef.api);
				}}
				gridProps={{
					overlayNoRowsTemplate: "No Data",
					rowSelection: "single",
					onSelectionChanged: onSelectHandler,
				}}
			/>
			<div className='tp-segment'>
				<TPDropDown
					disabled={!selectedTPL?.key}
					label={t("LBL_FLD_TYPE")}
					options={fieldTypeDropDownItems}
					style={{marginBottom: '12px'}}
					value={
						selectedTPL?.FIELDTYPE || "CONSTANT"
					}
					onChange={(e) => {
						changeHandler("FIELDTYPE", e.target.value);
					}}
				/>
				{/* Uncomment when functionality will be implemented */}
				{selectedTPL?.FIELDTYPE !== "CONSTANT" ? (
					<SourceType
						node={{
							PARENT: selectedTPL?.PARENT,
							MAPNAME: selectedTPL?.MAPNAME,
							RECORD_TYPE: selectedTPL?.RECORD_TYPE,
							ACTION: selectedTPL?.ACTION,
							INDEX: selectedTPL?.INDEX,
							CUSTOM_DB_FIELD: selectedTPL?.CUSTOM_DB_FIELD,
							PLUGIN_NAME: selectedTPL?.PLUGIN_NAME,
							key: selectedTPL?.id,
						} || {}}
						valuesHandler={valuesHandler}
						source={"TRADING_PARTNER"}
						includeTrailer={true}
						allowAllTreeSelection={true}
						disabled={!selectedTPL?.hasOwnProperty("key")}
					/>
				) : (
					<FormControl className='width-100' size='small'>
						<TextField
							disabled={!selectedTPL?.key}
							variant='outlined'
							size='small'
							autoComplete='off'
							type='text'
							className={"width-100"}
							value={constantValue}
							label={t("LBL_CONST_VAL")}
							name={""}
							onChange={(e) => {
								debounceChangeHandler("VALUE", e.target.value);
								setConstantValue(e.target.value);
							}}
						/>
					</FormControl>
				)}
			</div>
			<AdvancedProperties
				disabled={!selectedTPL?.key}
				selectedNode={selectedTPL}
				updatedSelectedNodeWithAdvanceProperties={updateSelectedNode}
			/>
		</Box>
	);
};

export default TradingPartnerData;
